import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnDestroy, input, viewChild, ChangeDetectorRef, inject, AfterViewInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'zui-local-search-field',
  templateUrl: './local-search-field.component.html',
  styleUrls: [ './local-search-field.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocalSearchFieldComponent implements OnDestroy, AfterViewInit {

  #cdRef = inject(ChangeDetectorRef);

  control = new UntypedFormControl('');

  name = 'localSearchField' + Date.now();
  @Input()
  placeholder: string;

  @Input()
  set value(v: string) {
    this.control.setValue(v, { emitEvent: false });
  }

  maxWidth = input<number>(250);
  autofocus = input(false);
  searchField = viewChild('searchField', { read: MatInput });

  @Output()
  valueChange = new EventEmitter<string>();

  private _sub = this.control.valueChanges
    .pipe(filter((v) => v !== undefined))
    .subscribe((v) => this.valueChange.emit(v));

  ngAfterViewInit() {
    if (this.autofocus()) {
      // Small delay to ensure the view is fully rendered
      setTimeout(() => this.focus(), 100);
    }
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  focus() {
    this.searchField()?.focus();
    this.#cdRef.detectChanges();
  }

}
